"use client";

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import GroupItem from "./item/GroupItem";
import { CommunityMemberOverview } from "@/entities/IProfile";
import { Page } from "@/helpers/Types";
import { CommunityMembersQuery } from "@/app/network/page";
import { SortDirection } from "@/entities/ISort";
import { useEffect, useState } from "react";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { useDispatch } from "react-redux";
import { setActiveGroupId } from "@/store/groupSlice";
import { CommunityMembersSortOption } from "@/enums";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
export default function GroupsSelectActiveGroup(t0) {
  const $ = _c(24);
  const {
    activeGroupId
  } = t0;
  let t1;
  if ($[0] !== activeGroupId) {
    t1 = {
      queryKey: [QueryKey.GROUP, activeGroupId],
      queryFn: async () => await commonApiFetch({
        endpoint: `groups/${activeGroupId}`
      }),
      placeholderData: keepPreviousData
    };
    $[0] = activeGroupId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data
  } = useQuery(t1);
  let t2;
  let t3;
  if ($[2] !== activeGroupId) {
    t2 = [QueryKey.COMMUNITY_MEMBERS_TOP, {
      page: 1,
      pageSize: 1,
      sort: CommunityMembersSortOption.LEVEL,
      sortDirection: SortDirection.DESC,
      groupId: activeGroupId
    }];
    t3 = async () => await commonApiFetch({
      endpoint: "community-members/top",
      params: {
        page: 1,
        page_size: 1,
        sort: CommunityMembersSortOption.LEVEL,
        sort_direction: SortDirection.DESC,
        group_id: activeGroupId
      }
    });
    $[2] = activeGroupId;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const t4 = !!activeGroupId;
  let t5;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      placeholderData: keepPreviousData,
      enabled: t4
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data: members
  } = useQuery(t5);
  const [membersCount, setMembersCount] = useState(null);
  let t6;
  let t7;
  if ($[9] !== members) {
    t6 = () => {
      if (members) {
        setMembersCount(members.count);
      }
    };
    t7 = [members];
    $[9] = members;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  const dispatch = useDispatch();
  let t8;
  if ($[12] !== dispatch) {
    t8 = groupId => {
      dispatch(setActiveGroupId(groupId));
    };
    $[12] = dispatch;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const onActiveGroupId = t8;
  if (!data) {
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="tw-px-4 tw-text-md tw-text-iron-400 tw-font-normal">Loading...</div>;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    return t9;
  }
  let t9;
  if ($[15] !== membersCount) {
    t9 = typeof membersCount === "number" && <div className="tw-flex tw-items-center tw-gap-x-2 tw-mb-3"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="tw-w-5 tw-h-5 tw-flex-shrink-0 tw-text-iron-200"><path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" /></svg><p className="tw-whitespace-nowrap tw-text-xs tw-font-normal tw-text-iron-400 tw-mb-0">Members:{" "}<span className="tw-pl-1.5 tw-text-iron-50 tw-font-medium">{membersCount}</span></p></div>;
    $[15] = membersCount;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== activeGroupId || $[18] !== data || $[19] !== onActiveGroupId) {
    t10 = <GroupItem key={data.id} group={data} activeGroupId={activeGroupId} onActiveGroupId={onActiveGroupId} />;
    $[17] = activeGroupId;
    $[18] = data;
    $[19] = onActiveGroupId;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div className="tw-px-4 tw-pt-4">{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}